import { defineStore } from 'pinia'

export const useAdminSysTempStore = defineStore('adminSysTempStore', {
    state: () => ({
        isLoggedIn: false,          // 是否已經登入
        adminname: '',          
        isLoaded: false,       // 是否已經撈過資料
        payment_status_methods: [], // 付款狀態
        payment_methods:    [],     // 付款方式
        shipping_methods:   [],     // 運送方式
        order_status_codes :    [], // 訂單狀態
        productTypes: [],          // 商品類型
    }),
    actions: {
        async fetchAdminCheckLogin() {
            try {
                const res = await fetch('/api/admin/checklogin')
                const json = await res.json()
                this.isLoggedIn = json.isLoggedIn
                this.adminname = json.adminname
            } catch (err) {
                console.error('fetch error:', err)
            }
        },
        async fetchAdminSysTempData() {
            if (this.isLoaded) return // 已載入過就直接 return
            try {
                const res = await fetch('/api/admin/loadconifg')
                const json = await res.json()
                if (json.success) {
                    this.payment_status_methods = json.payment_status_methods
                    this.payment_methods = json.payment_methods
                    this.shipping_methods = json.shipping_methods
                    this.order_status_codes = json.order_status_codes
                    this.isLoaded = true
                } else {
                    console.warn('取得 fetchAdminSysTempData 資料失敗', json.message)
                }
            } catch (err) {
                console.error('fetch error:', err)
            }
        },

        /**
         * 載入商品設置檔
         */
        async fetchProductTypesData() {
            if(this.product_types) return
            try {
                const res = await fetch('/api/admin/loadproducttypes')
                const json = await res.json()
                if (json.success) {
                    this.product_types = json.product_types
                } else {
                    console.warn('取得 fetchProductTypesData 資料失敗', json.message)
                }
            } catch (err) {
                console.error('fetch error:', err)
            }
        },

        async fetchSetAdminName( adminname ) {

            try {
                this.isLoggedIn = true
                this.adminname = adminname

            } catch (err) {
                console.error('fetch error:', err)
            }
        },

        async fetchLoggedOff() {

            try {
                this.isLoggedIn = false
                this.adminname = null

            } catch (err) {
                console.error('fetch error:', err)
            }
        }
    },
})
